/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
// Extend From
import Route from '@ember/routing/route';
// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// External Imports
import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';
// Internal Imports
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import Staff from '@linc-technologies/linced-common/enums/roles/staff';
import {
  SuspensionCategory,
  SuspensionTabs,
} from '@linc-technologies/linced-common/enums/suspensions';

export default class SuspensionsRoute extends Route {
  queryParams = {
    dateFrom: {
      refreshModel: true,
    },
    dateTo: {
      refreshModel: true,
    },
    selectedTab: {
      refreshModel: true,
    },
  };

  // Services
  @service
  session;

  @service
  store;

  isPrincipal(person) {
    if (isEmpty(person.roles)) {
      return false;
    }
    return person.roles.includes(Staff.PRINCIPAL);
  }

  model(params) {
    let suspensionQuery = {
      category: 0,
      date: '',
      dateFrom: '',
      dateTo: '',
      extended: false,
      pending: false,
      schoolId: this.get('session.activeSchool'),
    };
    switch (params.selectedTab) {
      case SuspensionTabs.PENDING:
        suspensionQuery.pending = true;
        break;
      case SuspensionTabs.FORMAL_CAUTIONS:
        suspensionQuery.category = SuspensionCategory.FORMAL_CAUTION;
        break;
      case SuspensionTabs.SUSPENSIONS:
        suspensionQuery.dateFrom = moment().format('YYYY-MM-DD');
        break;
      case SuspensionTabs.EXTENDED_SUSPENSIONS:
        suspensionQuery.dateFrom = moment().format('YYYY-MM-DD');
        suspensionQuery.extended = true;
        break;
      case SuspensionTabs.COMPLETED_SUSPENSIONS:
        suspensionQuery.dateFrom = params.dateFrom;
        suspensionQuery.dateTo = params.dateTo;
        break;
    }

    return hash({
      expulsions: null,
      suspensionPage: this.store
        .query('posts/page', {
          isSuspensionPosts: true,
        })
        .then((pages) => {
          return pages[0];
        }),
      suspensionLettersPage: this.store
        .query('posts/page', {
          isSuspensionLetters: true,
        })
        .then((pages) => {
          return pages[0];
        }),
      suspensions: this.store.query('attendance/suspension', suspensionQuery),
      // Resolved to a plain array: the {{reverse}} template helper calls
      // A() on it, which throws on ember-data's live-array proxy.
      terms: this.store.findAll('term').then((terms) => terms.slice()),
      behaviourIncidents: this.store.query('attendance/behaviour-incident', {
        schoolId: this.get('session.activeSchool'),
      }),
      principal: (async () => {
        const staff = await this.store.query('person', {
          type: PersonType.STAFF,
        });
        const principals = staff.filter((person) => this.isPrincipal(person));

        for (const principal of principals) {
          const users = await this.store.query('user', {
            personId: principal.id,
          });
          const user = users.at(0);
          if (user && !user.get('disabled')) {
            return principal;
          }
        }
        return null;
      })(),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    if (!isEmpty(model.suspensions)) {
      let suspensionIds = model.suspensions.map((suspension) => {
        return suspension.get('id');
      });
      return this.store
        .query('attendance/expulsion', {
          schoolId: this.get('session.activeSchool'),
          suspensionIds: JSON.stringify(suspensionIds),
        })
        .then((res) => {
          return (model.expulsions = res);
        });
    }
  }
}
